module.exports = __webpack_public_path__ + "static/img/set.84aae33f.png";